import { onCleanup } from './cleanup.js'

/**
 * Activa las animaciones de entrada por scroll.
 * @param {Document|Element} container Ámbito de búsqueda de elementos animables
 */
function animations (container = document) {
  // WeakSet en lugar de Set: guarda los elementos ya animados sin impedir que
  // el GC los libere cuando la transición los saca del documento. Con un Set
  // fuerte cada nodo animado quedaba retenido para siempre (nodo zombie).
  const observedElements = new WeakSet()
  const animations = container.querySelectorAll('.anim')

  if (animations.length > 0) {
    const triggerAnim = (entries) => {
      entries.forEach((entry) => {
        const element = entry.target
        const delay = element.dataset.delay || 0
        const speed = element.dataset.speed + 's' || '1s'
        const once = element.dataset.once ?? 'false'
        const mobile = element.dataset.mobile ?? 'true' // Default to true

        const applyAnimation = () => {
          setTimeout(() => {
            element.style.animationDuration = speed
            element.classList.add('anim-on')
            if (once === 'true') {
              observedElements.add(element)
            }
          }, delay)
        }

        const isMobile = window.innerWidth < 992

        if (entry.isIntersecting || element.classList.contains('force')) {
          if (mobile === 'true' || !isMobile) { // Apply animation if mobile is true OR not a mobile device
            if (element.classList.contains('anim-img')) {
              const img = element.querySelector('img')
              if (img) {
                if (img.complete) {
                  applyAnimation()
                } else {
                  img.addEventListener('load', applyAnimation, { once: true })
                }
              } else {
                applyAnimation()
              }
            } else {
              applyAnimation()
            }
          }
        } else {
          if (once !== 'true') {
            element.classList.remove('anim-on')
          }
        }
      })
    }

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.4
    }

    const observer = new IntersectionObserver(triggerAnim, options)

    animations.forEach(element => {
      observer.observe(element)
    })

    // Sin esto, el observer seguía vivo observando nodos ya destruidos por la
    // transición y los mantenía alcanzables desde la raíz.
    onCleanup(() => observer.disconnect())

    // Trigger animations for elements with .force class on page load
    container.querySelectorAll('.force').forEach(element => {
      const delay = element.dataset.delay || 0
      const speed = element.dataset.speed + 's' || '1s'
      const mobile = element.dataset.mobile ?? 'true' // Default to true
      const isMobile = window.innerWidth < 992

      const applyForceAnimation = () => {
        setTimeout(() => {
          element.style.animationDuration = speed
          element.classList.add('anim-on')
        }, delay)
      }

      if (mobile === 'true' || !isMobile) { // Apply animation if mobile is true OR not a mobile device
        if (element.classList.contains('anim-img')) {
          const img = element.querySelector('img')
          if (img) {
            if (img.complete) {
              applyForceAnimation()
            } else {
              img.addEventListener('load', applyForceAnimation, { once: true })
            }
          } else {
            applyForceAnimation()
          }
        } else {
          applyForceAnimation()
        }
      }
    })
  }
}

export default animations
